import { useEffect, useState } from "react";
import { BRAND } from "@/lib/data";
import { LOADER } from "@/constants/testIds";

export default function Loader({ minMs = 900 }) {
    const [hidden, setHidden] = useState(false);
    const [fading, setFading] = useState(false);

    useEffect(() => {
        const start = performance.now();
        const finish = () => {
            const elapsed = performance.now() - start;
            const remaining = Math.max(0, minMs - elapsed);
            setTimeout(() => {
                setFading(true);
                setTimeout(() => setHidden(true), 700);
            }, remaining);
        };
        if (document.readyState === "complete") {
            finish();
        } else {
            window.addEventListener("load", finish, { once: true });
            // Fallback in case load never fires
            setTimeout(finish, 2500);
        }
        return () => window.removeEventListener("load", finish);
    }, [minMs]);

    if (hidden) return null;
    return (
        <div
            data-testid={LOADER.root}
            className={`fixed inset-0 z-[100] bg-[#0A0A0A] flex flex-col items-center justify-center transition-opacity duration-700 ${
                fading ? "opacity-0 pointer-events-none" : "opacity-100"
            }`}
        >
            <img
                src={BRAND.logo}
                alt="Loading"
                className="w-24 h-24 logo-spin"
                style={{ filter: "brightness(0) invert(1)" }}
            />
            <p className="mt-8 overline text-[#A8A8A8]">Curating your experience</p>
        </div>
    );
}
